import React from 'react';
import PropTypes from 'prop-types';
import Fuse from 'fuse.js';
import { uniqWith, isEqual } from 'lodash';

import SingleCabin from './singleCabin';
import PersonCluster from './personCluster';

import { activePersonForImportedFile } from './activePersonForImportedFile';
import { createPersonWithId } from './createPersonWithId';

import '../../importFile.css';

class CabinDistributor extends React.Component {

  constructor() {
    super();
    this.state = {
      cabinTabOut: 'out',
      cabinTabAvailableFull: 'available',
    };
  }

  componentDidMount() {
    const {
      cabinData,
      cabinsOut,
      cabinsHome,
      importedFileTitleRow,
      formattedFile,
      setActivePersonForImportedFileCabinDistributor,
      setActiveCabinForImportedFileCabinDistributor,
      allRemainingCabinsIdsWithoutGuests,
    } = this.props;
    const cabinIndex = this.getCabinIndex(importedFileTitleRow);
    const availableCabinsOut = cabinsOut && cabinsOut.filter(cabin => allRemainingCabinsIdsWithoutGuests.includes(cabin));
    const availableCabinsHome = cabinsHome && cabinsHome.filter(cabin => allRemainingCabinsIdsWithoutGuests.includes(cabin));
    let filterOutCabinsInFile = [];
    if (cabinIndex !== -1) {
      filterOutCabinsInFile = formattedFile.map(row => (row[cabinIndex] && row[cabinIndex].value) || null).filter(row => row);
    }
    const matchingIndexes = this.returnClosestMatch(filterOutCabinsInFile);
    const matchingPersons = this.returnMatchingPersons(matchingIndexes, formattedFile);
    let cabinsLeftOut = availableCabinsOut.length;
    let cabinsLeftHome = availableCabinsHome.length;
    matchingPersons.map((row, i) => {
      const makeId = this.makeid();
      const sendDataWithId = createPersonWithId(row, importedFileTitleRow, makeId);
      const objectToSend = activePersonForImportedFile(sendDataWithId);
      let cabinId = '';
      if (cabinsOut && this.allCabinsAreTheSameForOut(cabinsOut)) {
        cabinId = availableCabinsOut[i];
        if (cabinId) {
          setActiveCabinForImportedFileCabinDistributor(cabinId);
          const remainingBeds = cabinData.filter(cabin => cabin.id === cabinId).map(c => c && c.noOfBerths).toString() || 0;
          if (row.length <= remainingBeds) {
            setActivePersonForImportedFileCabinDistributor(objectToSend);
            cabinsLeftOut -= 1;
          }
        }
        if (i >= (matchingPersons.length - 1) && cabinsLeftOut === 0) {
          this.changeCabinAvailableFullTab('full');
          setActiveCabinForImportedFileCabinDistributor('');
        }
      }
      if (cabinsHome && this.allCabinsAreTheSameForHome(cabinsHome)) {
        cabinId = availableCabinsHome[i];
        if (cabinId) {
          setActiveCabinForImportedFileCabinDistributor(cabinId);
          const remainingBeds = cabinData.filter(cabin => cabin.id === cabinId).map(c => c && c.noOfBerths).toString() || 0;
          if (row.length <= remainingBeds) {
            setActivePersonForImportedFileCabinDistributor(objectToSend);
            cabinsLeftHome -= 1;
          }
        }
        if (i >= (matchingPersons.length - 1) && cabinsLeftHome === 0) {
          this.changeCabinAvailableFullTab('full');
          setActiveCabinForImportedFileCabinDistributor('');
        }
      }
      return null;
    });
  }

  getFullCabinNumber = () => {
    const { cabinsOut, cabinsHome, personsLinkedToCabin } = this.props;
    if (this.state.cabinTabOut === 'out') {
      return personsLinkedToCabin.map(p => cabinsOut.includes(p.cabin)).filter(a => a);
    }
    return personsLinkedToCabin.map(p => cabinsHome.includes(p.cabin)).filter(a => a);
  }

  getAvailableCabinNumber = () => {
    const { cabinData, cabinsOut, cabinsHome, personsLinkedToCabin } = this.props;
    if (this.state.cabinTabOut === 'out') {
      return cabinData.filter(c => cabinsOut.includes(c.id)).filter(c => c.guests.length <= 0).length - personsLinkedToCabin.filter(p => cabinsOut.includes(p.cabin)).length;
    }
    return cabinData.filter(c => cabinsHome.includes(c.id)).filter(c => c.guests.length <= 0).length - personsLinkedToCabin.filter(p => cabinsHome.includes(p.cabin)).length;
  }

  getCabinIndex = (titleRow) => {
    const cabinIndexFromTitleRow = titleRow.map(a => a && a.name === 'cabin').indexOf(true);
    return cabinIndexFromTitleRow;
  };

  changeCabinTab(clickState) {
    this.setState({ cabinTabOut: clickState, cabinTabAvailableFull: 'available' });
  }

  changeCabinAvailableFullTab(clickState) {
    this.setState({ cabinTabAvailableFull: clickState });
  }

  returnArrayLowerCase = array => array.map((obj) => {
    obj.toLowerCase();
    return obj;
  });

  returnClosestMatch = (array) => {
    const lowerCaseArray = this.returnArrayLowerCase(array);
    const options = {
      threshold: 0,
      includeScore: true,
      matchAllTokens: true,
      tokenize: true,
    };
    const fuse = new Fuse(lowerCaseArray, options);
    const result = [];
    lowerCaseArray.map(a => result.push(fuse.search(a)));
    const filterOutBadResults = result.map(r => r.filter(s => s.score === 0.000));
    const filterOutUniquValues = uniqWith(filterOutBadResults, isEqual);
    return filterOutUniquValues;
  };

  makeid = () => {
    let text = '';
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    for (let i = 0; i < 10; i += 1) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  };

  returnMatchingPersons = (array, file) => {
    const personsToStayInCabins = array.map(a => a && a.map(item => file && file[item && item.item + 1]));
    return personsToStayInCabins;
  };

  allCabinsAreTheSameForOutHome = cabinData => cabinData.filter(c => c && c.linkedCabins.length > 0).length === cabinData.length;

  allCabinsAreTheSameForOut = cabinOut => cabinOut.map(c => c.split('--')[0]).filter((item, pos, self) => self.indexOf(item) === pos).length === 1;

  allCabinsAreTheSameForHome = cabinHome => cabinHome.map(c => c.split('--')[0]).filter((item, pos, self) => self.indexOf(item) === pos).length === 1;

  personsMatchingToCabinsInFile = (
      titleRow,
      file,
      setActiveCabinForImportedFileCabinDistributor,
      setActivePersonForImportedFileCabinDistributor,
      activePersonInCabinDistributor,
      personsLinkedToCabin,
      getRemainingBeds,
    ) => {
    const cabinIndex = this.getCabinIndex(titleRow);
    let filterOutCabinsInFile = [];
    if (cabinIndex !== -1) {
      filterOutCabinsInFile = file.map(row => (row[cabinIndex] && row[cabinIndex].value) || null).filter(row => row);
    }
    const matchingIndexes = this.returnClosestMatch(filterOutCabinsInFile);
    const matchingPersons = this.returnMatchingPersons(matchingIndexes, file);
    for (let i = 0; i < matchingPersons.length; i += 1) {
      matchingPersons[i].toManyPassengersForCabin = matchingPersons[i].length > getRemainingBeds;
    }
    matchingPersons.sort(this.sortArray);
    return this.renderPersonCluster(
        matchingPersons,
        titleRow,
        setActiveCabinForImportedFileCabinDistributor,
        setActivePersonForImportedFileCabinDistributor,
        activePersonInCabinDistributor,
        personsLinkedToCabin,
      );
  };

  sortArray = (a, b) => {
    if (a.toManyPassengersForCabin < b.toManyPassengersForCabin) {
      return -1;
    }
    if (a.toManyPassengersForCabin > b.toManyPassengersForCabin) {
      return 1;
    }
    return 0;
  };

  shouldRenderCabinsOutOrHome = (cabinData, cabinsOut, cabinsHome) => {
    if (this.state.cabinTabOut === 'home') {
      return this.renderCabinsHome(cabinData, cabinsHome);
    }
    return this.renderCabinsOut(cabinData, cabinsOut);
  }

  renderCabinsOut = (cabinData, cabinsOut) => this.renderSingleCabin(cabinData, cabinsOut);

  renderCabinsHome = (cabinData, cabinsHome) => this.renderSingleCabin(cabinData, cabinsHome);

  renderSingleCabin = (cabinData, fromOrHome) => {
    const {
      setActiveCabinForImportedFileCabinDistributor,
      activeCabinInCabinDistributor,
      personsLinkedToCabin,
      removePersonFromPersonsLinkedToCabinImportedFile,
      selectCabinInfoStartedDescription,
      selectCabinInfoEmptyDescription,
    } = this.props;
    const { cabinTabAvailableFull } = this.state;
    return cabinData && cabinData.map((cabin) => {
      const personsInCabin = (personsLinkedToCabin && personsLinkedToCabin.some(p => p.cabin === cabin.id));
      if (fromOrHome && fromOrHome.includes(cabin.id) && (cabinTabAvailableFull === 'available' ? !personsInCabin : personsInCabin) && (cabin.guests && cabin.guests.length <= 0)) {
        return (
          <li key={cabin.id} id={cabin.id}>
            <SingleCabin
              activeCabinInCabinDistributor={activeCabinInCabinDistributor}
              data={cabin}
              setActiveCabinForImportedFileCabinDistributor={setActiveCabinForImportedFileCabinDistributor}
              personsLinkedToCabin={personsLinkedToCabin}
              personsInCabin={personsInCabin}
              removePersonFromPersonsLinkedToCabinImportedFile={removePersonFromPersonsLinkedToCabinImportedFile}
              selectCabinInfoStartedDescription={selectCabinInfoStartedDescription}
              selectCabinInfoEmptyDescription={selectCabinInfoEmptyDescription}
            />
          </li>
        );
      }
      return null;
    });
  };

  renderPersonCluster = (
      matchingPersons,
      titleRow,
      setActiveCabinForImportedFileCabinDistributor,
      setActivePersonForImportedFileCabinDistributor,
      activePersonInCabinDistributor,
      personsLinkedToCabin,
    ) => matchingPersons.map((row, i) => {
      const makeId = this.makeid();
      const sendDataWithId = createPersonWithId(row, titleRow, makeId);
      const rowId = this.makeid();
      const outAndHomeCabins = this.state.cabinTabOut === 'out' ? this.props.cabinsOut : this.props.cabinsHome;
      const alreadyChoosen = (personsLinkedToCabin && personsLinkedToCabin.some(p => p.guests && p.guests.clusterId === sendDataWithId.id && outAndHomeCabins.includes(p.cabin))) || false;
      if (alreadyChoosen) {
        return null;
      }
      return (
        <PersonCluster
          key={rowId}
          data={sendDataWithId}
          index={i}
          setActiveCabinForImportedFileCabinDistributor={setActiveCabinForImportedFileCabinDistributor}
          setActivePersonForImportedFileCabinDistributor={setActivePersonForImportedFileCabinDistributor}
          activePersonInCabinDistributor={activePersonInCabinDistributor}
          toManyPassengersForCabin={row.toManyPassengersForCabin}
        />
      );
    },
  );

  render() {
    const {
      importedFileTitleRow,
      formattedFile,
      cabinData,
      setActiveCabinForImportedFileCabinDistributor,
      setActivePersonForImportedFileCabinDistributor,
      activeCabinInCabinDistributor,
      activePersonInCabinDistributor,
      personsLinkedToCabin,
      cabinsOut,
      cabinsHome,
      selectCabinInfoParagraph,
      filterTabAvailableCabins,
      filterTabFullCabins,
      cabinDistributionDone,
      routeNameOut,
      routeNameHome,
      getRemainingBeds,
    } = this.props;
    const { cabinTabOut, cabinTabAvailableFull } = this.state;
    return (
      <div className="cabin-distributor-container">
        <ul className="cabin-distributor-cabins">
          <div className="cabin-distributor-tabs">
            <span className={cabinTabOut === 'out' ? 'selected-cabin-tab' : ''} role="button" tabIndex={0} onClick={() => this.changeCabinTab('out')}>
              {routeNameOut}
            </span>
            {cabinsHome.length
            ? <span className={cabinTabOut === 'home' ? 'selected-cabin-tab' : ''} role="button" tabIndex={0} onClick={() => this.changeCabinTab('home')}>
              {routeNameHome}
            </span>
            : null
            }
          </div>
          <div className={`cabin-distributor-available-full-cabins-tabs ${cabinTabOut} ${cabinsHome.length <= 0 ? 'only-out' : ''}`}>
            <span className={cabinTabAvailableFull === 'available' ? 'selected-cabin-tab' : ''} role="button" tabIndex={0} onClick={() => this.changeCabinAvailableFullTab('available')}>
              {this.getAvailableCabinNumber()} {filterTabAvailableCabins}
            </span>
            <span className={cabinTabAvailableFull === 'full' ? 'selected-cabin-tab' : ''} role="button" tabIndex={0} onClick={() => this.changeCabinAvailableFullTab('full')}>
              {this.getFullCabinNumber().length} {filterTabFullCabins}
            </span>
          </div>
          {this.shouldRenderCabinsOutOrHome(cabinData, cabinsOut, cabinsHome, personsLinkedToCabin)}
        </ul>
        <ul className="cabin-distributor-persons">
          <div className="cabin-distributor-available-passengers">
            {activeCabinInCabinDistributor.length
            ? this.personsMatchingToCabinsInFile(
              importedFileTitleRow,
              formattedFile,
              setActiveCabinForImportedFileCabinDistributor,
              setActivePersonForImportedFileCabinDistributor,
              activePersonInCabinDistributor,
              personsLinkedToCabin,
              getRemainingBeds,
            )
            : <span>
              {this.getAvailableCabinNumber() === 0 && cabinTabAvailableFull === 'full' ? cabinDistributionDone : null}
              {this.getAvailableCabinNumber() !== 0 && cabinTabAvailableFull === 'available' ? selectCabinInfoParagraph : cabinDistributionDone}
            </span>
          }
          </div>
        </ul>
      </div>
    );
  }
}

CabinDistributor.propTypes = {
  importedFileTitleRow: PropTypes.array,
  formattedFile: PropTypes.array,
  cabinData: PropTypes.array,
  setActiveCabinForImportedFileCabinDistributor: PropTypes.func,
  setActivePersonForImportedFileCabinDistributor: PropTypes.func,
  activeCabinInCabinDistributor: PropTypes.string,
  activePersonInCabinDistributor: PropTypes.string,
  personsLinkedToCabin: PropTypes.array,
  cabinsOut: PropTypes.array,
  cabinsHome: PropTypes.array,
  removePersonFromPersonsLinkedToCabinImportedFile: PropTypes.func,
  allRemainingCabinsIdsWithoutGuests: PropTypes.array,
  cabinInstructionList: PropTypes.string,
  cabinsAllocatedInfo: PropTypes.string,
  selectCabinInfoCompleteDescription: PropTypes.string,
  selectCabinInfoEmptyDescription: PropTypes.string,
  selectCabinInfoErrorDescription: PropTypes.string,
  selectCabinInfoHeading: PropTypes.string,
  selectCabinInfoParagraph: PropTypes.string,
  selectCabinInfoSelectCabin: PropTypes.string,
  selectCabinInfoStartedDescription: PropTypes.string,
  filterTabAvailableCabins: PropTypes.string,
  filterTabFullCabins: PropTypes.string,
  cabinDistributionDone: PropTypes.string,
  routeNameOut: PropTypes.string,
  routeNameHome: PropTypes.string,
  getRemainingBeds: PropTypes.number,
};

export default CabinDistributor;



// WEBPACK FOOTER //
// ./src/components/organisms/ImportFile/steps/cabin/cabinDistributor.js